import React from "react";
import NavBar from "../Admin/Dashboard/NavBar";
import ReactProSidebar from "../Admin/Dashboard/ReactProSidebar";
import {
  Box,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Divider,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

export default function ViolationRule() {
  const navigate = useNavigate();

  const styles = {
    icon: {
      color: "#1976d2",
      fontSize: "31px",
    },
  };

  const rules = [
    {
      id: "i",
      text: "Belongs to another person and to which the user does not have any right",
    },
    {
      id: "ii",
      text: "Is obscene, pornographic, paedophilic, invasive of another‟s privacy including bodily privacy, insulting or harassing on the basis of gender, racially or ethnically objectionable, relating or encouraging money laundering or an online game that causes user harm, or promoting enmity between different groups on the grounds of religion or caste with the intent to incite violence;",
    },
    { id: "iii", text: "Is harmful to child" },
    {
      id: "iv",
      text: "Infringes any patent, trademark, copyright or other proprietary rights",
    },
    {
      id: "v",
      text: "Deceives or misleads the addressee about the origin of the message or knowingly and intentionally communicates any misinformation or information which is patently false and untrue or misleading in nature or, in respect of any business of the Central Government, is identified as fake or false or misleading by such fact check unit of the Central Government as the Ministry may, by notification published in the Official Gazette, specify",
    },
    { id: "vi", text: "Impersonates another person" },
    {
      id: "vii",
      text: "Threatens the unity, integrity, defence, security or sovereignty of India, friendly relations with foreign States, or public order, or causes incitement to the commission of any cognisable offence, or prevents investigation of any offence, or is insulting other nation",
    },
    {
      id: "viii",
      text: "Contains software virus or any other computer code, file or program designed to interrupt, destroy or limit the functionality of any computer resource",
    },
    {
      id: "ix",
      text: "Is in the nature of an online game that is not verified as a permissible online game",
    },
    {
      id: "x",
      text: "Is in the nature of advertisement or surrogate advertisement or promotion of an online game that is not a permissible online game, or of any online gaming intermediary offering such an online game",
    },
    {
      id: "xi",
      text: "Violates any law for the time being in force.",
    },
  ];

  return (
    <div className="container">
      <NavBar />
      <main>
        <Tooltip title="Back" placement="right">
          <IconButton
            onClick={() => navigate("/crawledInformation")}
            sx={styles.backButton}
          >
            <ArrowBack sx={styles.icon} />
          </IconButton>
        </Tooltip>
        <Box sx={{ display: "flex" }}>
          <Box
            // component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              backgroundColor: "#f0f1f3",
              // height: "100vh",
              // overflow: "none",
            }}
          >
            <Container maxWidth="lg">
              <Paper elevation={3} sx={{ p: 4, my: 3 }}>
                <Typography variant="h4" gutterBottom color="primary">
                  Intermediary Guidelines and Digital Media Ethics Code
                </Typography>
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  Section 3(1)(b)
                </Typography>
                <Chip
                  label="Government Regulation"
                  color="primary"
                  sx={{ mt: 1, marginBottom: 2 }}
                />
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    mb: 4,
                    backgroundColor: "#f8f9fa",
                    p: 2,
                    borderRadius: 1,
                    marginBottom:2
                  }}
                >
                  The intermediary shall inform its rules and regulations,
                  privacy policy and user agreement to the user in English or
                  any language specified in the Eighth Schedule to the
                  Constitution in the language of his choice and shall make
                  reasonable efforts by itself, and to cause the users of its
                  computer resource to not host, display, upload, modify,
                  publish, transmit, store, update or share any information
                  that,—
                </Typography>
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      backgroundColor: "#1AACAC",
                      "&:hover": { backgroundColor: "primary.light" },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: "white",
                        fontSize: "1.08rem",
                        fontWeight: "700",
                      }}
                    >
                      Rules & Regulations
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {rules.map((rule, index) => (
                      <Box key={index} sx={{ mb: 2 }}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            display: "flex",
                            gap: 2,
                            color: "text.primary",
                            fontWeight: 500,
                          }}
                        >
                          <span style={{ minWidth: "25px" }}>{rule.id})</span>
                          {rule.text}
                        </Typography>
                        {index < rules.length - 1 && <Divider sx={{ my: 2 }} />}
                      </Box>
                    ))}
                  </AccordionDetails>
                </Accordion>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    mb: 4,
                    backgroundColor: "#f8f9fa",
                    p: 2,
                    borderRadius: 1,
                  }}
                >
                  Explanation.—In this clause, “user harm” and “harm” mean any
                  effect which is detrimental to a user or child, as the case
                  may be
                </Typography>
                <Box
                  sx={{
                    mt: 4,
                    p: 2,
                    backgroundColor: "#fff3e0",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="subtitle2" color="warning.dark">
                    Note: These rules are subject to amendments and
                    notifications published in the Official Gazette.
                  </Typography>
                </Box>
              </Paper>
            </Container>
          </Box>
        </Box>
      </main>
      <ReactProSidebar />
    </div>
  );
}
